import React from 'react';
import { usePendingDowngrade } from '../../hooks/usePendingDowngrade';
import DowngradeWizard from './DowngradeWizard';

/**
 * @fileoverview Wrapper que detecta pending downgrades y muestra el wizard automáticamente
 * Debe colocarse en un nivel alto de la app (ej: App.tsx o Layout principal)
 */

interface DowngradeWizardWrapperProps {
  children: React.ReactNode;
}

export default function DowngradeWizardWrapper({ children }: DowngradeWizardWrapperProps) {
  const {
    pendingDowngrade,
    isChecking,
    wizardOpen,
    onWizardComplete,
    onWizardCancel,
  } = usePendingDowngrade();
  
  return (
    <>
      {children}
      
      {/* Wizard de downgrade (se muestra automáticamente si hay pending) */}
      {pendingDowngrade && (
        <DowngradeWizard
          fromPlanId={pendingDowngrade.fromPlanId}
          toPlanId={pendingDowngrade.toPlanId}
          isOpen={wizardOpen}
          onComplete={onWizardComplete}
          onCancel={onWizardCancel}
        />
      )}
    </>
  );
}
